module.exports = __webpack_public_path__ + "static/media/Liftquest.f9df6b4e.mp4";